import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from '../services';
import { Permission } from '@shared/data-access';
import { PAGE_ROUTES } from '@shared/core-data';

export const permissionGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPermissions = route.data['permissions'] as Permission[];

  if (
    !requiredPermissions ||
    permissionService.hasAnyPermission(requiredPermissions)
  ) {
    return true;
  }

  router.navigate(['/', PAGE_ROUTES.STATUS, PAGE_ROUTES.ACCESS_DENIED]).then();
  return false;
};
